export { LiberacionEntregaEdit } from "./edit";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/edit/index.tsx